<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Faqs"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <label>Pregunta</label>
              <ValidationProvider
                ref="question"
                rules=""
                v-slot="{ errors }"
              >
                <v-textarea
                  :error-messages="errors"
                  v-model="data.question"
                  solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label>Respuesta</label>
              <ValidationProvider
                  ref="answer"
                  rules=""
                  v-slot="{ errors }"
              >
                <v-textarea
                    :error-messages="errors"
                    v-model="data.answer"
                    solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
        status: state => state.Faqs.status,
      })
    },
    data() {
      return {
        storeName: 'Faqs',
        title: "FAQ's",
        data: {
          question: '',
          answer:'',
        }
      }
    }
  }
</script>
